import * as React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { filterBy } from "@progress/kendo-data-query";
import { useNominalsBySubType } from "services/nominalsService";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { v4 as uuidV4 } from "uuid";
import { Form, FormElement,  Field} from "@progress/kendo-react-form";
import { AmountFormatCell } from "components/common/formatter";
import { Button } from "@progress/kendo-react-buttons";
import { useState, useEffect, useRef, useCallback } from "react";
import SearchComboBox from "components/common/SearchComboBox";
import CONSTANT from "CONSTANT/Matter/ComboxType";
import { Label } from "@progress/kendo-react-labels";
import { useActiveVats } from "services/vatService";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";

const DateCell = (props) => {
  const { dataItem, field, onChange } = props;
  const hasError = dataItem.hasDateError || !dataItem.date || dataItem.date === null;
  
  return (
    <td className="p-2">
      <div style={hasError ? { border: "1px solid red", borderRadius: "4px" } : {}}>
        <DatePicker
          value={dataItem.date}
          toggleButton={CalenderCustomToggleButton}
          onChange={(e) => {
            onChange({
              dataItem: dataItem,
              field: field,
              syntheticEvent: e,
              value: e.value
            });
          }}
          placeholder="Select Date"
          width="100%"
        />
      </div>
    </td>
  );
};

const DetailsCell = (props) => {
  const { dataItem, field, onChange } = props;
  const style = dataItem.hasDetailsError 
    ? { border: "1px solid red", width: "100%" } 
    : { width: "100%" };
  
  return (
    <td className="p-2">
      {dataItem.inEdit ? (
        <Input 
          type="text" 
          value={dataItem[field] || ''} 
          onChange={(e) => {
            onChange({
              dataItem: dataItem,
              field: field,
              syntheticEvent: e,
              value: e.value
            });
          }}
          style={style}
        />
      ) : (
        dataItem[field]
      )}
    </td>
  );
};

const ValueCellComponent = (props) => {
  const { dataItem, field, onChange } = props;
  const style = dataItem.hasValueError 
    ? { border: "1px solid red", width: "100%" } 
    : { width: "100%" };
  
  return (
    <td className="p-2">
      <NumericTextBox
        format={props.format || "n2"}
        className="mt-auto right-align"
        value={dataItem[field] !== undefined ? dataItem[field] : 0}
        onChange={(e) => {
          if (onChange) {
            onChange({
              dataItem: dataItem,
              field: field,
              syntheticEvent: e.syntheticEvent,
              value: e.value
            });
          }
        }}
        spinners={false}
        style={style}
      />
    </td>
  );
};

const BillExpenseGrid = (props) => {
  const initialData = [
    {
      timeId: uuidV4(),
      type: "Expense",
      date: new Date(),
      details: "",
      netAmount: 0,
      vatAmount: 0,
      gross: 0,
      vatCode: 0,
    },
  ];

  const allInEdit = initialData.map((item) =>
    Object.assign(
      {
        inEdit: true,
      },
      item
    )
  );
  const [data, setData] = React.useState(allInEdit);
  const [error, setError] = useState(undefined);
  const [error1, setError1] = useState(undefined);
  const [gridErrors, setGridErrors] = useState([]);

  const [vatvalue, setvatvalue] = useState();
  const [nominal, setnominal] = useState();
  const [nominaldata, setnominaldata] = React.useState();
  const [formInitialValues, setFormInitialValues] = useState({});

  const hasInitializedVat = useRef(false);

  const { data: activevatsdata = [] } = useActiveVats();

  const calculateVatGross = () => {
    const updatedData = data.map((item) => {
      if (item.netAmount !== undefined && item.netAmount !== null) {
        const vatAmount = (vatvalue?.rate / 100) * item.netAmount;
        return {
          ...item,
          vatAmount: vatAmount,
          gross: item.netAmount + vatAmount
        };
      }
      return item;
    });
    setData(updatedData);
  };
  const addNew = () => {
    const uniqueTimeId = uuidV4();
    const newDataItem = {
      inEdit: true,
      timeId: uniqueTimeId,
      type: "Expense",
      date: new Date(),
      details: "",
      netAmount: 0,
      vatAmount: 0,
      gross: 0,
      vatCode: 0,
    };
    setData([...data, newDataItem]);
    
    if (gridErrors.length > 0) {
      setGridErrors([]);
    }
  };

  const onChangenominal = useCallback((event) => {
    setnominal(event?.value || null);
    setError(false); // Clear error when user makes a change
  }, []);
  
  const onChangevat = useCallback((event) => {
    setvatvalue(event.value);
    setError(false); 
    if (event.value !== null && event.value !== undefined) {
      const updatedData = data.map((item) => {
        if (item.netAmount !== undefined && item.netAmount !== null) {
          const vatAmount = (event.value?.rate / 100) * item.netAmount;
          return {
            ...item,
            vatAmount: vatAmount,
            gross: item.netAmount + vatAmount
          };
        }
        return item;
      });
      setData(updatedData);
    }
  }, [data]);
  const filternominalData = (filter) => {
    const data = nominallist.slice();
    return filterBy(data, filter);
  };
  const filternominal = (event) => {
    setnominaldata(filternominalData(event.filter));
  };

  const { data: incomeNominals } = useNominalsBySubType(
    "ProfitAndLoss_Income",
    { excludeArchived: true },
  );
  const nominallist = incomeNominals || [];

  const handleSubmit = (values) => {
    const currentVat = values.vatCode || vatvalue;
    const currentNominal = values.nominalRef || nominal;
    
    if (!currentVat || !currentNominal || !values.feeEarner) {
      setError(true);
      return;
    }
    
    if (data.length === 0) {
      setError1(true);
      return;
    }
    
    // Validate each row in the grid
    const errors = [];
    const hasInvalidRows = data.some((item, index) => {
      const rowErrors = [];
      
      // Check if date is null, undefined, or invalid
      if (!item.date || !(item.date instanceof Date) || isNaN(item.date.getTime())) {
        rowErrors.push("Date is required");
      }
      
      if (!item.details || item.details.trim() === "") {
        rowErrors.push("Details is required");
      }
      
      if (!item.netAmount || item.netAmount <= 0) {
        rowErrors.push("Value must be greater than 0");
      }
      
      if (rowErrors.length > 0) {
        errors.push({
          rowIndex: index + 1,
          errors: rowErrors
        });
        return true;
      }
      return false;
    });
    
    if (hasInvalidRows) {
      setGridErrors(errors);
      return;
    }
    
    setGridErrors([]);
    
    const updatedData = data.map((item) => ({
      ...item,
      feeEarnerRef: values.feeEarner?.userRef,
      nominalRef: currentNominal?.nominalRef,
      vatCode: currentVat?.vatCodeId
    }));

    props.changeMatterList(updatedData);
    const uniqueTimeId = uuidV4();
    setData([{ inEdit: true, timeId: uniqueTimeId }]);
    props.cancelEdit();
  };
  const itemChange = (e) => {
    let newData = data.map((item) => {
      if (item.timeId === e.dataItem.timeId) {
        item[e.field || ""] = e.value;
      }
      return item;
    });
    setData(newData);
    
    if (gridErrors.length > 0) {
      setGridErrors([]);
    }
    
    if (e.field === "netAmount") {
      calculateVatGross();
    }
  };

  const addDefaultValues = useCallback(async () => {
    const defaultVat = await activevatsdata.find(
      (item) => item.vatCodeId === props.defaultValues?.defaultVatCodeId
    );
    if (defaultVat) {
      onChangevat({value: defaultVat, event: {value: defaultVat}});
      setvatvalue(defaultVat);
      setFormInitialValues(prev => ({...prev, vatCode: defaultVat}));
    }
  }, [activevatsdata, props.defaultValues?.defaultVatCodeId, onChangevat]);

  useEffect(() => {
    if(activevatsdata.length > 0 && props.defaultValues?.defaultVatCodeId && !vatvalue && !hasInitializedVat.current) {
      addDefaultValues();
      hasInitializedVat.current = true;
    }
  }, [activevatsdata, props.defaultValues?.defaultVatCodeId, vatvalue, addDefaultValues]);

  const requiredValidator = (value) => {
    return value ? undefined : " "; 
  };

  useEffect(() => {
    if (incomeNominals && incomeNominals.length > 0) {
      setnominaldata(incomeNominals.slice());
      const nominal = incomeNominals.find(
        (item) => item.nominalRef === props.defaultValues?.defaultProfitNominal
      );
      if (nominal) {
        setnominal(nominal);
        setFormInitialValues(prev => ({...prev, nominalRef: nominal}));
      }
    }
  }, [incomeNominals, props.defaultValues?.defaultProfitNominal]);

  const dataWithValidation = data.map((item, index) => {
    const rowIndex = index + 1;
    const rowError = gridErrors.find(err => err.rowIndex === rowIndex);
    
    return {
      ...item,
      hasDetailsError: rowError?.errors.some(e => e.includes("Details")),
      hasValueError: rowError?.errors.some(e => e.includes("Value")),
      hasDateError: rowError?.errors.some(e => e.includes("Date"))
    };
  });

  return (
    <Dialog title={`Expenses`} onClose={props.cancelEdit} className="dialog-xl">
      <div
        className="d-flex flex-column h-100 overflow-hidden"
        style={{ minHeight: 0 }}
      >
        <div className="flex-shrink-0 pt-4 pb-3 px-5">
          <div className="d-flex flex-wrap align-items-center validation">
            <Form
              ignoreModified={true}
              onSubmit={handleSubmit}
              id="timeRecord"
              initialValues={formInitialValues}
              key={JSON.stringify(formInitialValues)}
              render={(formRenderProps) => {
                return (
                  <div>
                    <FormElement id="timeRecord" name="timeRecord" noValidate>
                      <fieldset>
                        {formRenderProps.visited &&
                          formRenderProps.errors &&
                          formRenderProps.errors.VALIDATION_SUMMARY && (
                            <div className={"k-messagebox k-messagebox-error"}>
                              {formRenderProps.errors.VALIDATION_SUMMARY}
                            </div>
                          )}

                        <div className="d-flex">
                          <div
                            className="d-flex flex-column mb-3 me-3"
                            style={{ width: "300px" }}
                          >
                            <Label>Vat Code</Label>
                            <Field
                              name="vatCode"
                              component={ComboBox}
                              validator={requiredValidator}
                              validationMessage=""
                              style={{ width: "300px" }}
                              className="mt-1"
                              data={activevatsdata}
                              textField="display"
                              value={vatvalue}
                              iconClassName="wa"
                              onChange={onChangevat}
                              placeholder="Search VAT Code"
                            />
                          </div>

                          <div
                            className="d-flex flex-column mb-3 me-3"
                            style={{ width: "300px" }}
                          >
                            <Label>Nominal Ref</Label>
                            <Field
                              name="nominalRef"
                              component={ComboBox}
                              validator={requiredValidator}
                              validationMessage=""
                              className="mt-1"
                              style={{ width: "300px" }}
                              data={nominaldata}
                              iconClassName="wa"
                              textField="display"
                              filterable={true}
                              onFilterChange={filternominal}
                              value={nominal}
                              onChange={onChangenominal}
                              placeholder="Search Nominal Ref"
                            />
                          </div>

                          <div className="mb-3">
                            <Field
                              name="feeEarner"
                              component={SearchComboBox}
                              cbType={CONSTANT.FE}
                              validator={requiredValidator}
                              className="mt-1"
                              iconClassName="wa"
                              width="300px"
                              placeholder="Search Fee Earner Ref"
                              defaultValues={props.defaultValues}
                              defaultValueSetter={formRenderProps}
                            />
                          </div>
                        </div>
                      </fieldset>
                    </FormElement>
                  </div>
                );
              }}
            />
          </div>
        </div>

        <div
          className="flex-grow-1 d-flex flex-column px-5 pb-3"
          style={{ minHeight: 0 }}
        >
          <Grid
            data={dataWithValidation}
            className="grid-header-sm mt-1"
            style={{ height: "100%", minHeight: 0 }}
            editField="inEdit"
            onItemChange={itemChange}
            dataItemKey={"timeId"}
          >
            <Column
              field="date"
              title="Date"
              format="{0:d}"
              width={"200px"}
              headerClassName="ps-3"
              cell={DateCell}
            />
            <Column 
              field="details" 
              title="Details" 
              width={"200px"} 
              cell={DetailsCell} 
            />
            <Column
              field="netAmount"
              editor="numeric"
              title="Value"
              cell={ValueCellComponent}
              className="p-2"
            />
            <Column
              field="vatAmount"
              title="Vat"
              editable={false}
              cell={AmountFormatCell}
              className="p-2"
            />
            <Column
              field="gross"
              title="Gross"
              editable={false}
              cell={AmountFormatCell}
              className="p-2"
            />
          </Grid>
          {error1 === true && (
            <i style={{ color: "red" }}>Select atleast 1 Record</i>
          )}
          <div className="flex-shrink-0">
            <Button
              title="Add new"
              className="common-btn thirdButton"
              style={{ marginTop: "10px" }}
              onClick={addNew}
            >
              Add new line
            </Button>
          </div>
        </div>
      </div>

      <DialogActionsBar>
        <div className="dialog-footer w-100">
          <button
            type="button"
            className="common-btn bgBtnSecondary border-0 me-3"
            onClick={() => {
              props.cancelEdit();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="timeRecord"
            className="k-button common-btn me-4"
          >
            Add to Bill
          </button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export default BillExpenseGrid;
